import { render, staticRenderFns } from "./confirmForm.vue?vue&type=template&id=6cdca758&scoped=true&"
import script from "./confirmForm.vue?vue&type=script&lang=js&"
export * from "./confirmForm.vue?vue&type=script&lang=js&"
import style0 from "./confirmForm.vue?vue&type=style&index=0&id=6cdca758&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdca758",
  null
  
)

export default component.exports